import { useEffect, useState } from 'react';

const DEFAULT_INTRO_DELAY_MS = 550;
const DEFAULT_CTA_GAP_MS = 480;

/**
 * Staggered reveal for PDF preview intro bubble + CTA button (worker registry, hire health, etc.).
 */
export function useStaggeredPreviewCta(
  enabled: boolean,
  introDelayMs = DEFAULT_INTRO_DELAY_MS,
  ctaGapMs = DEFAULT_CTA_GAP_MS
) {
  const [showIntro, setShowIntro] = useState(false);
  const [showCta, setShowCta] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setShowIntro(false);
      setShowCta(false);
      return;
    }
    const tIntro = window.setTimeout(() => setShowIntro(true), introDelayMs);
    const tCta = window.setTimeout(() => setShowCta(true), introDelayMs + ctaGapMs);
    return () => {
      window.clearTimeout(tIntro);
      window.clearTimeout(tCta);
    };
  }, [enabled, introDelayMs, ctaGapMs]);

  return { showIntro, showCta };
}
